/**
 * Validation helpers for the Min/Max numeric range filter (Searches / Exports) on the
 * Free Lookup Administration page. Both bounds are optional, non-negative integers, inclusive.
 * Kept free of react-admin imports so they can be unit tested in isolation.
 */

export const NUMERIC_RANGE_FIELDS = ['searches', 'exports'];

export const isNumericRangeField = (field?: string): boolean =>
    !!field && NUMERIC_RANGE_FIELDS.includes(field);

const isEmpty = (value: any): boolean =>
    value === undefined || value === null || value === '';

const isNonNegativeInteger = (value: any): boolean => {
    const text = String(value).trim();
    return /^\d+$/.test(text) && Number.isSafeInteger(Number(text));
};

/** Field-level validator: empty is allowed; otherwise a non-negative integer is required. */
export const validateNonNegativeInteger = (value: any): string | undefined => {
    if (isEmpty(value)) return undefined;
    return isNonNegativeInteger(value) ? undefined : 'Enter a non-negative whole number';
};

/** Validator for the Max input: must not be smaller than Min (only checked when both are valid). */
export const validateMaxNotBelowMin = (max: any, allValues: any): string | undefined => {
    const min = allValues?.searchFrom;
    if (isEmpty(max) || isEmpty(min)) return undefined;
    if (!isNonNegativeInteger(max) || !isNonNegativeInteger(min)) return undefined;
    return Number(max) < Number(min) ? 'Max must be greater than or equal to Min' : undefined;
};
